import React from 'react';
import { Field } from 'react-final-form';

type ChildrenFunction = (values: any) => React.ReactElement | null;

interface Props {
    children: React.ReactElement | ChildrenFunction;
    name: string;
}

const FieldValue = ({ children, name }: Props): React.ReactElement => (
    <Field
        name={name}
        subscription={{
            value: true
        }}
    >
        {({ input: { value } }: any): React.ReactElement | null => {
            // If function attach the prop to the children
            if (typeof children === 'function') {
                return children(value);
            }

            // If element attach the prop to the children
            return React.cloneElement(children, {
                [name]: value
            });
        }}
    </Field>
);

export default FieldValue;
